import { oapi as bapi, fileUrl } from '@/lib/officialsApi';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const FILE_PREFIX = `${API_URL}/api/files/`;

export const shareUrl = (id) => `${window.location.origin}/b/${id}`;

export async function fetchBracketPreview(format, numTeams, { teams, positions } = {}) {
  const res = await fetch(`${API_URL}/api/bracket-preview`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ format, num_teams: numTeams, teams, positions: positions || undefined }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || 'Bracket could not be loaded');
  return data;
}
export const logoPathOf = (logo) => (logo && logo.startsWith(FILE_PREFIX) ? logo.slice(FILE_PREFIX.length) : '');
export const logoUrlOf = (path) => fileUrl(path) || '';

export function sharePayload(templateId, c, settings) {
  return {
    template_id: templateId,
    title: c.title || '',
    date: c.date || '',
    names: Object.fromEntries(Object.entries(c.names || {}).filter(([, v]) => v && v.trim())),
    scores: c.scores || {},
    logo_path: logoPathOf(c.logo),
    settings: settings || {},
    event_id: c.eventId || '',
  };
}

// The in-browser logo is uploaded only when a bracket is shared.
export async function uploadLogo(dataUrl) {
  const blob = await (await fetch(dataUrl)).blob();
  const form = new FormData();
  form.append('file', blob, 'bracket-logo.png');
  const r = await bapi('/upload/event-logo', { method: 'POST', body: form });
  return logoUrlOf(r.storage_path);
}

export const shareApi = {
  get: (id, view) => bapi(`/bracket-shares/${id}`, { query: view ? { view: 1 } : {} }),
  mine: () => bapi('/bracket-shares/mine'),
  create: (body) => bapi('/bracket-shares', { method: 'POST', body }),
  update: (id, body) => bapi(`/bracket-shares/${id}`, { method: 'PUT', body }),
  remove: (id) => bapi(`/bracket-shares/${id}`, { method: 'DELETE' }),
};

export const teamListApi = {
  list: () => bapi('/team-lists'),
  leagues: () => bapi('/team-lists/leagues'),
  create: (body) => bapi('/team-lists', { method: 'POST', body }),
  update: (id, body) => bapi(`/team-lists/${id}`, { method: 'PUT', body }),
  remove: (id) => bapi(`/team-lists/${id}`, { method: 'DELETE' }),
};
